import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {PackagingLabel} from '../../../Models/PackagingLabel';
import {PackagingLabelItem} from '../../../Models/PackagingLabelItem';
import {debounceTime, distinctUntilChanged, switchMap} from 'rxjs/operators';
import {PackagingLabelService} from '../../../Services/packaging-label.service';
import {DealersService} from '../../../Services/dealers.service';

@Component({
  selector: 'app-generate-packaging-label',
  templateUrl: './generate-packaging-label.component.html',
  styleUrls: ['./generate-packaging-label.component.scss'],
  exportAs: 'generatePackagingLabel'
})
export class GeneratePackagingLabelComponent implements OnInit {
  @ViewChild('generatePackagingLabelModal', {static: false}) generatePackagingLabelModal;
  @ViewChild('createPackagingLabelForm', {static: false}) createPackagingLabelForm: NgForm;
  @Input() packagingLabel: PackagingLabel = new PackagingLabel();
  @Input() hideDeliveryDealer = false;
  @Output() $resultPL: EventEmitter<any> = new EventEmitter<any>();
  public dealers$ = [];
  public dealerTypeHead = new EventEmitter<string>();

  constructor(private packagingLabelService: PackagingLabelService, private dealersService: DealersService) {
  }

  ngOnInit() {
    this.loadDealers();
    this.packagingLabel.packagingLabelItems = [new PackagingLabelItem()];
  }

  closeGeneratePackagingLabelModal() {
    this.generatePackagingLabelModal.hide();
    this.packagingLabel.packagingLabelItems = [new PackagingLabelItem()];
    this.createPackagingLabelForm.reset();
  }

  openGeneratePackagingLabelModal() {
    this.generatePackagingLabelModal.show();
  }

  removePackagingLabelItem(i: number) {
    this.packagingLabel.packagingLabelItems.splice(i, 1);
    this.packagingLabel.packagingLabelItems = JSON.parse(JSON.stringify(this.packagingLabel.packagingLabelItems));
  }

  addPackagingLabelItem() {
    this.packagingLabel.packagingLabelItems.push(new PackagingLabelItem());
  }

  generatePackagingLabel() {
    this.packagingLabelService.createPackagingLabel(this.packagingLabel).subscribe(res => {
      this.closeGeneratePackagingLabelModal();
      this.$resultPL.emit(res);
    });
  }

  loadDealers() {
    if (this.packagingLabel.deliveryDealer) {
      this.dealers$.push(JSON.parse(JSON.stringify(this.packagingLabel.deliveryDealer)));
      this.packagingLabel.deliveryDealer = this.packagingLabel.deliveryDealer.id;
    }
    this.dealerTypeHead.pipe(
      distinctUntilChanged(),
      debounceTime(300),
      switchMap(term => this.dealersService.getDealers('query=' + term))
    ).subscribe(res => {
      this.dealers$ = res['data'];
    }, (err) => {
      this.dealers$ = [];
    });
  }

  showDialog() {
    this.openGeneratePackagingLabelModal();
  }

}
